export const GET_ALL_USERS = "GET_ALL_USERS";
export const GET_TOTAL_USERS = "GET_TOTAL_USERS";
export const GET_ATTRIBUTES ="GET_ATTRIBUTES"
export const VIEW_ITEM_DETAIL = "VIEW_ITEM_DETAIL";
export const GET_ITEM_LISTING = "GET_ITEM_LISTING";
export const GET_ALL_PAST_AUCTIONS = "GET_ALL_PAST_AUCTIONS";
export const GET_ALL_RUNNING_AUCTIONS = "GET_ALL_RUNNING_AUCTIONS";
export const GET_ITEM_TOTAL = "GET_ITEM_TOTAL";
export const GET_PAST_TOTAL = "GET_PAST_TOTAL";
export const GET_RUNNING_TOTAL = "GET_RUNNING_TOTAL";
export const GET_ALL_BID_AUCTIONS = "GET_ALL_BID_AUCTIONS";
export const GET_BID_TOTAL = "GET_BID_TOTAL";
export const GET_ALL_CATEGORIES = "GET_ALL_CATEGORIES";
export const GET_TOTAL_CATEGORIES = "GET_TOTAL_CATEGORIES";
export const GET_BADGE_LISTS = "GET_BADGE_LISTS";
export const GET_STAFF_LISTING="GET_STAFF_LISTING";
export const GET_SINGLE_STAFF="GET_SINGLE_STAFF";
export const USER_DISPUTES="USER_DISPUTES";
export const USER_FLAG_COMMENTS="USER_FLAG_COMMENTS";
export const GET_NEWSLETTER_LISTS = "GET_NEWSLETTER_LISTS";
export const GET_CONTACT_LISTS = "GET_CONTACT_LISTS";
export const GET_ORDER_LISTS = "GET_ORDER_LISTS";
export const GET_PAYMENT_LISTS = "GET_PAYMENT_LISTS";
export const GET_ANALYTICS_DATA = "GET_ANALYTICS_DATA";
export const GET_LOGS_DATA = "GET_LOGS_DATA";
export const GET_PRODUCT_DETAIL = "GET_PRODUCT_DETAIL";
